import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'

const BASE = '/messaggi-interni'

export interface UtenteMin {
  id: number
  nome?: string
  cognome?: string
  username: string
}

export interface MessaggioInterno {
  id: number
  tipo: 'direct' | 'broadcast'
  mittente_id: number
  destinatario_id?: number
  destinatario_ruolo_id?: number
  risposta_a_id?: number
  oggetto?: string
  testo: string
  created_at: string
  mittente?: UtenteMin
  destinatario?: UtenteMin
  letto: boolean
}

export interface MessaggioInternoCreate {
  tipo: 'direct' | 'broadcast'
  destinatario_id?: number
  destinatario_ruolo_id?: number
  oggetto?: string
  testo: string
}

export function useInbox() {
  return useQuery({
    queryKey: ['messaggi-interni', 'inbox'],
    queryFn: async () => {
      const res = await axiosInstance.get(`${BASE}/inbox`)
      return res.data as MessaggioInterno[]
    },
  })
}

export function useInviati() {
  return useQuery({
    queryKey: ['messaggi-interni', 'inviati'],
    queryFn: async () => {
      const res = await axiosInstance.get(`${BASE}/inviati`)
      return res.data as MessaggioInterno[]
    },
  })
}

export function useAlertsInterni() {
  return useQuery({
    queryKey: ['messaggi-interni', 'alerts'],
    queryFn: async () => {
      const res = await axiosInstance.get(`${BASE}/alerts`)
      return res.data as { non_letti: number }
    },
    refetchInterval: 30_000,
  })
}

export function useInviaMessaggioInterno() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: MessaggioInternoCreate) =>
      axiosInstance.post(BASE, data).then(r => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['messaggi-interni'] })
    },
  })
}

export function useThreadInterno(id?: number) {
  return useQuery({
    queryKey: ['messaggi-interni', 'thread', id],
    queryFn: async () => {
      const res = await axiosInstance.get(`${BASE}/${id}/thread`)
      return res.data as MessaggioInterno[]
    },
    enabled: !!id,
  })
}

export function useRispondiInterno() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, testo }: { id: number; testo: string }) =>
      axiosInstance.post(`${BASE}/${id}/rispondi`, { testo }).then(r => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['messaggi-interni'] })
    },
  })
}

export function useMarcaLetta() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) =>
      axiosInstance.patch(`${BASE}/${id}/letta`).then(r => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['messaggi-interni'] })
    },
  })
}
